import React from 'react'
import PropTypes from 'prop-types'

const CourseCard = props => {
  const selected = props.canvasCoursenum === props.course.id.toString()
  const bsBtnType = selected ? 'btn-success' : 'btn-primary'
  const btnText = selected ? (
    <span>
      Connected
      <i className="fas fa-check ml-2" />
    </span>
  ) : (
    'Connect'
  )

  return (
    <div className="col-md-4">
      <div className="card shadow my-3">
        <div className="card-body">
          <h6 className="card-title color-primary font-title text-bold">
            {props.course.name}
          </h6>
          <p className="card-subtitle font-title text-muted">
            {props.course.course_code}
          </p>
          {props.course.term ? (
            <p className="card-subtitle font-title text-muted">
              Term: {props.course.term.name}
            </p>
          ) : null}
          {props.course.start_at ? (
            <p className="card-subtitle font-title text-muted">
              Start Date: {props.course.start_at.substring(0, 10)}
            </p>
          ) : null}
          {props.course.workflow_state ? (
            <p className="card-subtitle font-title text-muted">
              Workflow State: {props.course.workflow_state}
            </p>
          ) : null}
          {props.course.public_description ? (
            <p className="card-subtitle font-title text-muted">
              Description: {props.course.public_description}
            </p>
          ) : null}
          {props.course.course_format ? (
            <p className="card-subtitle font-title text-muted">
              Course Format: {props.course.course_format}
            </p>
          ) : null}
          {props.course.timezone ? (
            <p className="card-subtitle font-title text-muted">
              Timezone: {props.course.timezone}
            </p>
          ) : null}
          {props.course.sis_course_id ? (
            <p className="card-subtitle font-title text-muted">
              SIS Course ID: {props.course.sis_course_id}
            </p>
          ) : null}
          <div>
            <span className="badge badge-secondary font-title">
              <i className="fas fa-graduation-cap color-white mr-2" />
              Students
              <span className="badge badge-lg badge-light ml-2">
                {props.course.total_students}
              </span>
            </span>
          </div>
        </div>
        <div className="card-footer">
          <button
            className={`${bsBtnType} btn btn-sm btn-block`}
            disabled={props.submitting}
            onClick={() => props.onSubmit(props.course.id.toString())}
            type="button"
          >
            {btnText}
          </button>
        </div>
      </div>
    </div>
  )
}

CourseCard.propTypes = {
  canvasCoursenum: PropTypes.string.isRequired,
  course: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
}

export default CourseCard
